import {
  makeStyles,
  Spinner,
  Text,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    gap: '16px',
    backgroundColor: '#f5f5f5',
  },
  text: {
    fontSize: '14px',
    color: '#616161',
  },
});

interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Spinner size="large" />
      <Text className={styles.text}>{message}</Text>
    </div>
  );
}
